
export default {
    namespaced: true,
    state: {
        countryData: [],
        currentCountryId: null,
        currentBrand: null,
        historyData1: {},
        historyData2: {},
        historyData3: {},
        from: null,
        to: null,
    },
    getters: {
        CURRENT_BRAND: state => {
            return state.currentBrand;
        },
        HISTORY_DATA1: state => {
            return state.historyData1;
        },
        HISTORY_DATA2: state => {
            return state.historyData2;
        },
        HISTORY_DATA3: state => {
            return state.historyData3;
        },
        CURRENT_COUNTRY_ID: state => {
            return state.currentCountryId;
        },
        COUNTRY_DATA: state => {
            return state.countryData;
        },
        FROM: state => {
            return state.from;
        },
        TO: state => {
            return state.to;
        },
    },
    mutations: {
        CURRENT_BRAND: (state, payload) => {
            return state.currentBrand = payload;
        },
        HISTORY_DATA1: (state, payload) => {
            return state.historyData1 = payload;
        },
        HISTORY_DATA2: (state, payload) => {
            return state.historyData2 = payload;
        },
        HISTORY_DATA3: (state, payload) => {
            return state.historyData3 = payload;
        },
        CURRENT_COUNTRY_ID: (state, payload) => {
            return state.currentCountryId = payload;
        },
        COUNTRY_DATA: (state, payload) => {
            return state.countryData = payload;
        },
        FROM: (state, payload) => {
            return state.from = payload;
        },
        TO: (state, payload) => {
            return state.to = payload;
        },

    },
    actions: {
        GET_DATA: async ({state}, payload) => {
            payload.th.showOverlay ++;
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/analytics/sales-analytics/country-brand/' + state.currentBrand.id
                    + '?from='+ state.from +'&to='+ state.to,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    state.countryData = responseData.data
                },
                getResponse: () => {
                    payload.th.showOverlay --;
                },
            });
        },
        GET_HISTORY: async ({state}, payload) => {
            payload.th.showOverlay ++;
            state.historyData1 = {};
            state.historyData2 = {};
            state.historyData3 = {};
            await payload.th.$store.dispatch('SEND_GET', {
                url: '/analytics/sales-analytics/country-brand/chart/'+
                    state.currentCountryId +'/'+ state.currentBrand.id +
                    '?from='+ state.from +'&to='+ state.to,
                th: payload.th,
                showSuccessMessage: false,
                getSuccessResponse: (responseData) => {
                    let data = responseData.data
                    console.log(data)
                    state.historyData1 = {
                        labels: [],
                        datasets: [
                            {
                                label: 'Запросы',
                                // backgroundColor: 'rgba(255, 140, 0, 1)',
                                borderColor: '#FF8C00',
                                data: [],
                                fill: false,
                            },
                            {
                                label: 'КП',
                                // backgroundColor: 'rgba(0, 0, 255, 1)',
                                borderColor: '#0000FF',
                                data: [],
                                fill: false,
                            },
                            {
                                label: 'Заказы',
                                // backgroundColor: 'rgba(0, 128, 0, 1)',
                                borderColor: '#008000',
                                data: [],
                                fill: false,
                            },
                        ]
                    }
                    state.historyData2 = {
                        labels: [],
                        datasets: [
                            {
                                label: 'Средний чек',
                                backgroundColor: '#EE82EE',
                                data: [],
                            },
                        ]
                    }
                    state.historyData3 = {
                        labels: [],
                        datasets: [
                            {
                                label: 'Конверсия',
                                backgroundColor: '#FF0000',
                                data: [],
                            },
                        ]
                    }
                    for (let key in data) {
                        let val = data[key]
                        state.historyData1.labels.push(val.date);
                        state.historyData2.labels.push(val.date);
                        state.historyData3.labels.push(val.date);
                        state.historyData1.datasets[0].data.push(val.request);
                        state.historyData1.datasets[1].data.push(val.requisition);
                        state.historyData1.datasets[2].data.push(val.orderCount);
                        state.historyData2.datasets[0].data.push(val.averageCheck);
                        state.historyData3.datasets[0].data.push(val.conversion);
                    }
                },
                getResponse: () => {
                    payload.th.showOverlay --
                },
            });
        }
    }
}